module.exports = __webpack_public_path__ + "img/chevron-up.1be06328.svg";